import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { REALMS } from '../../data/realms';

export const RealmNavigator = ({ active }) => {
  const idx = REALMS.findIndex((r) => r.slug === active);
  const prev = REALMS[(idx - 1 + REALMS.length) % REALMS.length];
  const next = REALMS[(idx + 1) % REALMS.length];

  return (
    <nav className="rnav" aria-label="Realm navigator" data-testid="realm-navigator">
      <div className="rnav-inner">
        <Link to={`/realm/${prev.slug}`} className="rnav-arrow" aria-label={`Previous realm: ${prev.name}`} data-testid="realm-nav-prev">
          <ArrowLeft className="w-4 h-4" strokeWidth={1.25} />
        </Link>
        <div className="rnav-tabs">
          {REALMS.map((r) => (
            <Link
              key={r.slug}
              to={`/realm/${r.slug}`}
              className={`rnav-tab ${r.slug === active ? 'is-active' : ''}`}
              aria-current={r.slug === active ? 'page' : undefined}
              data-testid={`realm-nav-${r.slug}`}
            >
              <img src={r.sigil} alt="" className="rnav-sigil" draggable="false" aria-hidden />
              <span>{r.name}</span>
            </Link>
          ))}
        </div>
        <Link to={`/realm/${next.slug}`} className="rnav-arrow" aria-label={`Next realm: ${next.name}`} data-testid="realm-nav-next">
          <ArrowRight className="w-4 h-4" strokeWidth={1.25} />
        </Link>
      </div>
    </nav>
  );
};
